import { AppState } from '../types/store';
import { PaymentMethod } from '../types';

export const getAllowedPaymentMethods = (state: AppState) =>
  state?.checkoutPage?.checkout?.paymentMethods;

export const getEnableCoupons = (state: AppState) => {
  return state?.checkoutPage?.checkout?.orderV3?.couponEnabled;
};
export const getCoupon = (state: AppState) =>
  state?.checkoutPage?.checkout?.orderV3?.coupon;
export const getCouponCode = (state: AppState) => getCoupon(state)?.couponCode;
export const getCouponError = (state: AppState) => getCoupon(state)?.error;
export const getCouponApplied = (state: AppState) =>
  !!getCouponCode(state) && !getCouponError(state);

export const getPaymentMethod = (state: AppState) =>
  state?.checkoutPage?.activePaymentMethod ?? PaymentMethod.CREDIT_CARD;

export const getOrderV3 = (state: AppState) =>
  state?.checkoutPage?.checkout?.orderV3;

export const getExtraNote = (state: AppState) =>
  state?.checkoutPage?.form?.note || '';

export const getGiftIsAnon = (state: AppState) =>
  state?.checkoutPage?.form?.giftIsAnon ? true : false;

export const getGiftUser = (state: AppState) =>
  state?.checkoutPage?.checkout?.giftUser;

export const getOrderV3Info = (state: AppState) =>
  state?.checkoutPage?.checkout?.orderV3;

export const getGiftType = (state: AppState) => state?.checkoutPage?.giftType;

export const getErrorCode = (state: AppState) => state?.checkoutPage?.errorCode;

export const getCheckout = (state: AppState) => state?.checkoutPage?.checkout;

export const getStripePublishableKey = (state: AppState) =>
  state?.checkoutPage?.checkout?.stripePublishableKey;

export const getIsWalletsNotSupported = (state: AppState) => {
  if (!isExpressCheckoutEnabled(state)) {
    return true;
  }
  return state?.checkoutPage?.isWalletsNotSupported;
};

export const isExpressCheckoutEnabled = (state: AppState) => {
  const methods = state.checkoutPage?.checkout?.paymentMethods || [];
  return (
    methods.includes(PaymentMethod.GOOGLE_PAY) ||
    methods.includes(PaymentMethod.APPLE_PAY)
  );
};
